<template>
  <div class="board_wrap" :class="boardSection[0] === 'SHAR' ? 'ifs009' : ''" v-if="isPaper() === 1">

    <!-- [ 의사결정 왼쪽 숨김화면 ] -->
    <BoardOpinion
      ref="boardOpinion"
      class="hidden"
      :userInfo="userInfo"
      :paperInfo="paperInfo"
      :paperId="paperInfo.paperId"
      :boardMemberInfo="boardMemberInfo"
    />
    <!-- [ 업무보드 주화면 ] -->
    <BoardContent
      :userInfo="userInfo"
      :paperInfo="paperInfo"
      :boardSection="boardSection"
      :boardMemberInfo="boardMemberInfo"
      :todoSelectedblockId="todoId"
    />
  </div>
</template>

<script>
import axios from "axios";
/* 업무보드 css */
import Paging from "../../../../../assets/css/board.css";
/* 의사결정 왼쪽 숨김화면 */
import BoardOpinion from "../opinion/BoardOpinion";
/* 업무보드 주화면 */
import BoardContent from "../base/BoardContent";
/* 지연처리를 위한 플러그인 */
import lodash from "lodash";

export default {
  components: {
    BoardOpinion,
    BoardContent
  },
  data() {
    return {
      userInfo: {
        userId: "",
        userName: ""
      },
      /* 업무보드사용자목록 */
      boardMemberInfo: {
        userList: [],
        paperUser: [],
        projectUser: []
      },
      /* 업무보드 데이터 */
      paperInfo: {
        /* 업무보드 ID */
        paperId: this.$route.params.paperId,
        /* 업무보드 제목 */
        paperTitle: "",
        groupId: null,
        copyGroupId: null,
        /* 읽기전용여부 */
        readonly: 1,
        /* 내/외부망 구분 (IN, OUT) */
        inOutState: "IN",
        /* 보드권한 0:조회불가, 1:조회가능, 2:편집가능 */
        permission: 0,
        categoryInfo: { }
      },
      todoId: this.$route.params.todoId,
      boardSection: [ "" ],
      // state: { }
    };
  },
  watch: {
    paperInfo: {
      handler() {
        if (this.paperInfo && this.paperInfo.groupInfo) {
          let section = "";
          if(this.paperInfo.groupInfo.groupKbn == 'USER') {
            // 프라이빗
            section = "PRIV";
          }
          else if(this.paperInfo.groupInfo.groupKbn == 'PRO') {

            section = null;
          }
          else {
            // CFRC, SHAR
            section = this.paperInfo.groupInfo.groupKbn;
          }
          this.boardSection.splice(0, 1, section);
        }
      },
      deep: true,
    },
    boardSection: {
      handler() {
        let self = this;
        lodash.debounce(function(e) {
          if (self.boardSection[0] === "SHAR") {
            self.$refs.boardOpinion.$el.classList.add("hidden");
          }
          else {
            self.$refs.boardOpinion.$el.classList.remove("hidden");
          }
        }, 1000)();
      },
    },
  },
  mounted() {
    this.isPaper();
  },
  methods: {
    isPaper() {
      if (this.paperInfo.paperId.match(/^PAPE[0-9]{17}[a-zA-Z]{4}/)) {
        return 1;
      }
      else if (this.paperInfo.paperId.match(/^BLOC[0-9]{17}[a-zA-Z]{4}/)) {
        return 2;
      }
      return 0;
    }
  }
};
</script>
<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/base/BoardViewer.vue